import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledTwoColumnGrid = styled(StyledFlex)`
   display: grid;
   grid-template-columns: 334px 350px;
   grid-template-rows: 1fr;
   grid-column-gap: 60px;
   grid-row-gap: 16px;
`;

export const StyledSmsPreview = styled.div`
   position: relative;
   white-space: pre-line;
   background-color: #2fcc59;
   color: #ffffff;
   padding: 15px 25px;
   border-radius: 19px;
   width: 355px;
   overflow-wrap: break-word;
`;

StyledSmsPreview.displayName = 'StyledSmsPreview';

export const StyledSmsPreviewSvg = styled.svg`
   fill: #2fcc59;
   position: absolute;
   bottom: 0;
   left: -9px;
   width: 30px;
   height: 30px;
`;

StyledSmsPreviewSvg.displayName = 'StyledSmsPreviewSvg';
